// Navbar.js
import React from 'react';
import { Link } from 'react-scroll'; 
import './Navbar.css'; // Import the CSS

const Navbar = () => {
  return (
    <nav className="navbar">
      <ul>
        <li>
          <Link to="howToBuy" smooth={true} duration={500}>HOW TO BUY</Link>
        </li>
      </ul>
    </nav>
  );
};

export default Navbar;
